
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppConst } from '~/constants/App.constant';
import { IconsConst } from '~/constants/Icons.constant';
import { ApplianceType, SourceType } from '~/interfaces/device.interface';

@Component
export default class NetatmoIcon extends Vue {
    @Prop({ default: false }) readonly isDevice!: boolean;
    @Prop({ default: '' }) readonly type!: string;
    @Prop({ default: '' }) readonly applianceType!: ApplianceType;
    @Prop({ default: '' }) readonly sourceType!: SourceType;
    @Prop({ default: '' }) name!: string;
    @Prop({ default: false }) readonly isColored!: boolean;
    @Prop({ default: false }) readonly isStrokeThrough!: boolean;
    @Prop({ default: 'large' }) readonly size!: string;

    get iconClass() {
        let className = [];

        if (this.isDevice) {
            className = [this.getIcon(this.type, this.applianceType, this.sourceType)];
        } else {
            className = IconsConst.RoomsAssets[this.name] || [this.name];
        }

        className = className.map(
            icon => {
                let stringIcon = 'icon-' + icon;
                if (className.length > 1) {
                    stringIcon = stringIcon + ' is-overlay';
                }
                if (this.isColored) {
                    stringIcon = stringIcon + ' colored--primary';
                }
                if (this.isStrokeThrough) {
                    stringIcon = stringIcon + ' strikethrough';
                }
                if (this.size) {
                    stringIcon = stringIcon + ' ' + this.size;
                }
                return stringIcon;

            },
        );
        return [...className];
    }

    getIcon(type: string, applianceType?: ApplianceType, sourceType?: SourceType) {
        switch (applianceType) {
            case ApplianceType.DISHWASHER:
                return 'dishwasher';
            case ApplianceType.TUMBLE_DRYER:
                return 'dryer';
            case ApplianceType.LIGHT:
                return 'light';
            case ApplianceType.COOKING:
                return 'oven';
            case ApplianceType.FRIDGE_FREEZER:
                return 'fridge';
            case ApplianceType.MULTIMEDIA:
                return 'multimedia';
            case ApplianceType.RADIATOR:
            case ApplianceType.RADIATOR_WITHOUT_PILOT_WIRE:
                return 'heater';
            case ApplianceType.ROUTER:
                return 'internet-box';
            case ApplianceType.WASHING_MACHINE:
                return 'washing';
            case ApplianceType.WATER_HEATER:
                return 'domestic-hot-water';
            case ApplianceType.ELECTRIC_CHARGER:
                return 'electric-car';
            case ApplianceType.CURTAINS:
                return 'curtain';
            case ApplianceType.SHADE:
                return 'shade';
            case ApplianceType.FAN:
                return 'fan';
            case ApplianceType.OTHER:
                if (['NLP', 'NLPM', 'BNCS'].includes(type)) {
                    return 'sockets';
                } else {
                    return 'flash';
                }
            case ApplianceType.GARAGE_DOOR:
                return 'garage-open';
            case ApplianceType.GATE:
                return 'gate-open';
        }

        if (
            type === 'NLPS'
            || type === 'BNXM'
            || type === 'NLE'
            || type === 'NLY') {
            return 'energy-meter';
        }

        if (type === 'NLPC') {
            return sourceType === SourceType.SOLAR_PANEL ? 'solar-panel' : 'energy-meter';
        }

        if (AppConst.lights.includes(type)) {
            return 'light';
        }
        if (['NLP', 'NLPM', 'BNCS'].includes(type)) {
            return 'sockets';
        }
        if (type === 'BNAB') {
            return 'swing-shutters';
        }
        if (AppConst.shutters.includes(type)) {
            return 'shutters';
        }
        if (type === 'NLLF' || type === 'BNFC') {
            return 'ventilation';
        }
        if (type === 'BNS') {
            return 'smarther';
        }

        if (type === 'OTH') {
            return 'thermostat green-icon';
        }
        if (AppConst.thermostats.includes(type) || type === 'TPG' || type === 'OTM' || type === 'NVG') {
            return 'thermostat';
        }
        if (AppConst.fans.includes(type)) {
            return 'fan';
        }
        if (type === 'NRV' || type === 'BNTR') {
            return 'valve';
        }
        if (type === 'NLPO' || type === 'NLPD') {
            return 'flash';
        }
        if (type === 'BNCU') {
            return 'alarm-keypad';
        }
        if (type === 'BNEU') {
            return 'external-panel';
        }
        if (type === 'NACamera') {
            return 'indoor-camera';
        }
        if (type === 'NOC') {
            return 'outdoor-camera';
        }
        if (type === 'NOC-S') {
            return 'outdoor-camera-siren';
        }
        if (type === 'NAMain') {
            return 'main-module';
        }
        if (type === 'NSA' || type === 'NSD') {
            return 'smoke-detector';
        }
        if (type === 'NLG') {
            return 'light';
        }
        if (type === 'NAC') {
            return 'air-conditioner';
        }
        if (type === 'NCO') {
            return 'co-detector';
        }
        if (type === 'NACamDoorTag') {
            return 'other-tag';
        }
        if (type === 'NIS') {
            return 'siren';
        }
        if (type === 'NAModule1') {
            return 'outdoor-module';
        }
        if (type === 'NAModule2') {
            return 'anemometer';
        }
        if (type === 'NAModule3') {
            return 'rain-gauge';
        }
        if (type === 'NAModule4') {
            return 'indoor-module';
        }
        if (type === 'NLJ') {
            return 'garage';
        }
        if (type === 'NPC') {
            return 'pro-indoor-camera';
        }
        if (type === 'NDB') {
            return 'video-doorbell';
        }
        if (type === 'NHC' || type === 'NHC-PRO') {
            return 'air-quality';
        }
        if (type === 'NDL') {
            return 'door-lock';
        }
        return 'generic';
    }

}
